// extracted by mini-css-extract-plugin
export var firstColumn = "WasteTable-module--firstColumn--XjCEa";
export var recipePill = "WasteTable-module--recipePill--Ag0Fc";
export var wasteTable = "WasteTable-module--wasteTable--nGGAG";